module.exports = __webpack_public_path__ + "static/media/applications-permits.dbf37540.svg";